export class ShowMorePrefixModel {
  page = 'page';
  component = 'component';
}


// WEBPACK FOOTER //
// ./src/app/components/show-more-content-box/show-more-prefix.model.ts